import "../../components/button/StyledButton.css"
import AddEcomForm from "components/addEcomForm/AddEcomForm";
import { useGetEcomLatestQuery, useGetEcomVersionsQuery } from "api/api";
import * as z from "zod";
import { useMemo } from "react";
import { Box, CircularProgress, Container } from "@mui/material";

const AddEcomPage = () => {
  const { data: ecomVersions = null } = useGetEcomVersionsQuery();
  const { data: latestEcomData = [] } = useGetEcomLatestQuery();

  const schema = z.object({
    versionNumber: z
      .string()
      .min(1, { message: "Version Number is required" })
      .refine((val) => Number.isInteger(Number(val)), {
        message: "Must be a whole number",
      })
      .refine(
        (val) => !ecomVersions?.includes(Number(val)),
        { message: "This version already exists" }
      )
      .transform((val) => Number(val)),
    descriptionOfUpdate: z
      .string({ required_error: "Description of Update is required" })
      .min(1, { message: "Description of Update is required" })
      .max(500, { message: "Description of Update maximum length is 500 characters" }),
  });

  const generateNextVersionNumber = (arr) => {
    if (arr === null) return null;

    let number = 1;
    while (arr.includes(number)) {
      number++;
    }
    return number;
  };

  const recommendedNextVersionNum = useMemo(() => generateNextVersionNumber(ecomVersions), [ecomVersions]);


  // Render mock form while waiting on recommendedNextVersionNum (Bad Fix)
  if (!recommendedNextVersionNum) {
    return (
      <Container sx={{ marginBottom: 3 }}>
        <div style={{ width: '100%', height: '100%', background: 'white', boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.12)', borderRadius: 5, padding: 20, paddingLeft: 41, paddingTop: 37 }}>
          <Box sx={{ width: "100%" }}>
            <div style={{ width: '100%', height: '100%', color: '#1A1A1A', fontSize: 28, fontFamily: 'Helvetica Neue LT Std', fontWeight: '300', wordWrap: 'break-word', paddingBottom: 12 }}>
              Description
            </div>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
              <CircularProgress />
            </Box>
          </Box>
        </div>
      </Container>
    );
  }

  const inputLabels = [
    { name: "versionNumber", label: "Version Number", unit: "", value: recommendedNextVersionNum?.toString() ?? '', type: 'number', latestValue: latestEcomData['version'] ?? '', component: "FormTextField" },
    { name: "descriptionOfUpdate", label: "Description Of Update", unit: "", value: null, type: 'string', component: "FormTextField" },
  ];

  return (
    <AddEcomForm
      title="Description"
      inputLabels={inputLabels}
      stage={1}
      validationSchema={schema}
    />
  );
}

export default AddEcomPage;